// extracted by mini-css-extract-plugin
export default {"mnSwitchPageTab":"index_mnSwitchPageTab__2VMhV","mnSwitchPageTabLeft":"index_mnSwitchPageTabLeft__ejhkY","mnSwitchTabBorder":"index_mnSwitchTabBorder__0jFSm"};